import { createSelector, createSlice } from "@reduxjs/toolkit";

const initialState = {
    userDetails: {},
    childFuturePlanDetails: {},
    retirementPlanDetails: {}
}

const userSlice = createSlice({
    name: 'userData',
    initialState,
    reducers: {
        updateUserDetails: (state, action) => {
            state.userDetails = action.payload
        },
        updateChildFuturePlanDetails: (state, action) => {
            state.childFuturePlanDetails = action.payload
        },
        updateRetirementPlanDetails: (state, action) => {
            state.retirementPlanDetails = action.payload
        },
        resetDetails: (state) => {
            state.userDetails = {};
            state.childFuturePlanDetails = {};
            state.retirementPlanDetails = {};
        },
    },
    
})

export const getUserDetailsSelector = createSelector((state) => state?.userDetails, (userDetails) => userDetails);
export const getChildFuturePlanDetailsSelector = createSelector((state) => state?.userDetails, (childFuturePlanDetails) => childFuturePlanDetails);
export const getRetirementPlanDetailsSelector = createSelector((state) => state?.userDetails, (retirementPlanDetails) => retirementPlanDetails);

export const { updateUserDetails, resetDetails, updateChildFuturePlanDetails, updateRetirementPlanDetails } = userSlice.actions;

export default userSlice.reducer;